module.exports = __webpack_public_path__ + "static/media/gallery1.7f229b91.png";